/**
 * Attaches an event listener to event target
 * and returns dispose function
 *
 * @param {EventTarget} target
 * @param {string} type
 * @param {EventListenerOrEventListenerObject} handler
 * @param {boolean | AddEventListenerOptions} [options]
 * @return {function} dispose function
 */
export const addEventListener = (target, type, handler, options) => {
    target.addEventListener(type, handler, options);
    return () => target.removeEventListener(type, handler, options);
};

/**
 *
 * @param {Record<string, unknown>} object
 * @param {function([string, unknown]): boolean} filterFn
 * @return {Record<string, unknown>}
 */
